<ng-template
  #rutCallLogsCellRendererTmpl
  let-record="record"
  let-column="column"
  let-showRequestFn="showRequestFn"
  let-tableComponent="tableComponent"
>
  <ng-container [ngSwitch]="column.template || column.name">
    <td *ngSwitchCase="'warn-white-space'">
      <p *ngIf="tableComponent.selectedAlternateViewName == 'CarrierMismatch'; else defaultCarrierText"
        [highlight]="'(^[ ]+|[ ]+$)'" customClasses="bg-warning">{{record[column.name]}}</p>
      <ng-template #defaultCarrierText>
        {{record[column.name]}}
      </ng-template>
    </td>
    <td *ngSwitchCase="'startTime'">
      <div class="d-flex flex-row align-items-center text-nowrap ">
        <div>{{ record[column.name] | date: "yyyy-MM-dd HH:mm:ss.SSS":"UTC" }}</div>
        <div *ngIf="record['callGapSecs']" class="ml-1 flex-grow-1 text-right text-secondary small">
          {{record['callGapSecs']}}
        </div>
      </div>
    </td>
    <td *ngSwitchCase="'localStartTime'" class="text-nowrap">
      <div class="d-flex flex-row align-items-center text-nowrap ">
        <div>{{ record[column.name] | date: "yyyy-MM-dd HH:mm:ss.SSS"}}</div>
        <div *ngIf="record['callGapSecs']" class="ml-1 flex-grow-1 text-right text-secondary small">
          {{record['callGapSecs']}}
        </div>
      </div>
    </td>
    <td *ngSwitchCase="'userName'">
      <a href="javascript:false;" (click)="tableComponent.showMobileUser(record)">
        {{ record[column.name] }}
      </a>
    </td>
    <td *ngSwitchCase="'pointId'">
      <a href="javascript:false;" (click)="tableComponent.showPointId(record)">
        {{ record[column.name] }}
      </a>
    </td>
    <td *ngSwitchCase="'taskId'">
      <button (click)="tableComponent.showTask(record)"
        class="w-100 btn btn-link m-0 p-0">
        {{ record[column.name] }}
      </button>
    </td>
    <td *ngSwitchCase="'taskPointId'">
      <button (click)="tableComponent.showTaskPoint(record)"
        class="w-100 btn btn-link m-0 p-0">
        {{ record[column.name] }}
      </button>
    </td>
    <td *ngSwitchCase="'photos'">
      <app-rut-call-photos [callLogId]="record.id" [photoCnt]="record.photoCnt"></app-rut-call-photos>
    </td>
    <td *ngSwitchCase="'comments'">
      <div class="text-wrap">
      {{ record[column.name] }}
      </div>
    </td>
    <td
      fes-table-view-default-cell-renderer
      *ngSwitchDefault
      [column]="column"
      [record]="record"
      [tableComponent]="tableComponent"
    ></td>
  </ng-container>
</ng-template>

<app-rut-call-log-table #table
  [alternateViewsEnabled]="alternateViewsEnabled"
  [cellRendererTmplRef]="rutCallLogsCellRendererTmpl"
  [tabConfig]="tabConfig"
  [detailFn]="detailFn"
  [loadOnInit]="loadOnInit"
  [isActiveView]="tabConfig?.active!==false"
  [contextJson]="tabConfig?.viewInfo.id||contextJson"
  (contextJsonChange)="contextJsonChangeHandler?.($event, tabConfig)"
  (rowMouseOverEmitter)="rowMouseOverEmitter.emit($event)"
  (rowMouseOutEmitter)="rowMouseOutEmitter.emit($event)"
>
</app-rut-call-log-table>
